module.exports = __webpack_public_path__ + "img/kz.d37cbd6.svg";